import { Action, Reducer } from 'redux';
import { CLAIMS_LOADING, CLAIMS_LOADED, CLAIM_LOADING, CLAIM_LOADED, STATS_LOADING, STATS_LOADED } from './loss-adjuster.actions';
import { initialState } from './loss-adjuster.state';

export const LossAdjusterReducer: Reducer<any, Action> = (state = initialState, action: any) => {
    let newState = state;
    switch (action.type) {
        case STATS_LOADING:
            newState = { ...newState, loading: true, statsLoading: true, stats: {} };
            break;
        case STATS_LOADED:
            newState = { ...newState, loading: false, statsLoading: false, stats: action.payload.staticResult?.length ? action.payload.staticResult[0] : {} };
            break;
        case CLAIMS_LOADING:
            newState = { ...newState, loading: true, claimsLoading: true, totalClaimsCount: 0 };
            break;
        case CLAIMS_LOADED:
            newState = { ...newState, loading: false, claimsLoading: false, claims: action.payload.data, totalClaimsCount: action.payload.total };
            break;
        case CLAIM_LOADING:
            newState = { ...newState, claimLoading: true, claimInfo: null };
            break;
        case CLAIM_LOADED:
            newState = { ...newState, claimLoading: false, claimInfo: action.payload };
            break;
    }
    return newState;
}